import { PaymentListItemStatus } from '#/shared/api/generated/billing/models'
import { PAYMENT_TYPE } from '#/shared/ui/create-payment-modal'

import { PAYMENT_LIST_STATUS } from './use-shipment-payments'
import type { ShipmentPaymentItem } from './use-shipment-payments'

export const PAYMENT_ACTION_LAYOUT = {
  settle: 'settle',
  partial: 'partial',
  charging: 'charging',
  retry: 'retry',
  receipt: 'receipt',
  viewOnly: 'viewOnly',
} as const

export type PaymentActionLayout =
  (typeof PAYMENT_ACTION_LAYOUT)[keyof typeof PAYMENT_ACTION_LAYOUT]

const FAILED_STATUSES: ReadonlySet<string> = new Set([
  PaymentListItemStatus.failed,
  PaymentListItemStatus.payment_failed,
])

const SETTLED_STATUSES: ReadonlySet<string> = new Set([
  PaymentListItemStatus.paid,
  PaymentListItemStatus.charged,
])

export function getPaymentActionLayout(
  item: ShipmentPaymentItem,
): PaymentActionLayout {
  if (item.status === PaymentListItemStatus.refunded) {
    return PAYMENT_ACTION_LAYOUT.viewOnly
  }
  if (item.status === PaymentListItemStatus.processing) {
    return PAYMENT_ACTION_LAYOUT.charging
  }
  if (FAILED_STATUSES.has(item.status)) {
    return PAYMENT_ACTION_LAYOUT.retry
  }
  if (item.status === PAYMENT_LIST_STATUS.partiallyPaid) {
    return PAYMENT_ACTION_LAYOUT.partial
  }
  if (SETTLED_STATUSES.has(item.status)) {
    return item.paymentType === PAYMENT_TYPE.carrier_pay
      ? PAYMENT_ACTION_LAYOUT.viewOnly
      : PAYMENT_ACTION_LAYOUT.receipt
  }
  return PAYMENT_ACTION_LAYOUT.settle
}

export function canChargePayment(item: ShipmentPaymentItem): boolean {
  return item.paymentType === PAYMENT_TYPE.income
}

export function isPartialPayment(item: ShipmentPaymentItem): boolean {
  return getPaymentActionLayout(item) === PAYMENT_ACTION_LAYOUT.partial
}

export function canSendPaymentReceipt(item: ShipmentPaymentItem): boolean {
  const layout = getPaymentActionLayout(item)
  return (
    layout === PAYMENT_ACTION_LAYOUT.receipt ||
    layout === PAYMENT_ACTION_LAYOUT.partial
  )
}
